import { Subject } from 'rxjs/Subject';
import { BAppService } from './bApp.service';
import { BLogoutService } from './bLogout.service';
import { Router } from '@angular/router';
var BHTTPLoader = (function () {
    function BHTTPLoader(bAppService, bLogoutService, router) {
        this.bAppService = bAppService;
        this.bLogoutService = bLogoutService;
        this.router = router;
        this._isHTTPRequestInProgress = new Subject();
        this._isHTTPRequestInProgress$ = this._isHTTPRequestInProgress.asObservable();
    }
    BHTTPLoader.prototype.isHTTPRequestInProgress = function (bool) {
        this._isHTTPRequestInProgress.next(bool);
    };
    BHTTPLoader.prototype.alertError = function (error) {
        if (error.status < 200 || error.status > 500) {
            if (error.status === 0) {
                this.bAppService.openSnackBar('Connectivity issue');
            }
            else {
                this.bAppService.openSnackBar('Response failure');
            }
        }
        else if (error.status === 401) {
            this.bLogoutService.logout();
            this.router.navigate(['unauthorized']);
        }
        else if (error.error) {
            if (error.error instanceof Object) {
                this.bAppService.openSnackBar(error.error.message);
            }
            else {
                this.bAppService.openSnackBar(error.error);
            }
        }
        else {
            this.bAppService.openSnackBar('Response failure');
        }
    };
    return BHTTPLoader;
}());
export { BHTTPLoader };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/bHTTPLoader.ts.pre-build-optimizer.js